module.exports = __webpack_public_path__ + "img/content1.20c240c9.png";